<template>
  <div>
    <!-- Login -->
    <template v-if="hideLayout">
      <v-main>
        <router-view />
      </v-main>
    </template>

    <!-- Desktop-->
    <template v-else-if="$vuetify.breakpoint.mdAndUp">
      <v-main>
        <router-view />
      </v-main>
    </template>

    <!-- Tablet / móvil:  responsive -->
    <template v-else>
      <v-app-bar
        app
        color="white"
        elevation="1"
        class="game-mobile-appbar"
      >
        <router-link to="/" class="d-flex align-center nav-link">
          <v-icon color="amber darken-2" class="mr-2">
            mdi-flash
          </v-icon>

          <span class="game-title">ElectroLiga</span>
        </router-link>

        <v-spacer />

        <v-btn icon text @click="drawer = true">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        app
        temporary
        right
      >
        <v-list nav dense>
          <v-list-item class="mb-2">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                ElectroLiga
              </v-list-item-title>
              <v-list-item-subtitle>
                Menú principal
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="mb-2" />

          <v-list-item to="/" @click="drawer = false">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Inicio</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2" />

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Salir</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-main class="game-mobile-main">
        <router-view />
      </v-main>
    </template>
  </div>
</template>

<script>
export default {
  name: "GameLayout",

  data() {
    return {
      drawer: false,
    };
  },

  computed: {
    hideLayout() {
      return ["Login", "Singup", "Signup", "AuthCallback"].includes(
        this.$route.name
      );
    },
  },

  methods: {
    logout() {
      localStorage.removeItem("authToken");
      this.drawer = false;
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.nav-link {
  text-decoration: none;
  color: inherit;
}

.game-title {
  font-weight: 800;
  color: #1f2937;
  font-size: 16px;
}

.game-mobile-main {
  min-height: 100vh;
}

/* Solo móvil/tablet */
@media (max-width: 960px) {
  .game-mobile-main {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>